export default "__VITE_ASSET__Jx44jaYb__"